import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import { FormattedMessage } from 'react-intl';
import translations from '../../translations';
import Button from '@material-ui/core/Button';
import FormActions from '@afosto/app-components-react/Form/FormActions';

const IdealInfo = ({ setFormStep, setSelectedPaymentMethod }) => (
  <>
    <Typography variant="h6" component="div">
      <FormattedMessage {...translations.options.iDeal.steps.info.title} />
    </Typography>
    <Typography component="p" variant="body2">
      <FormattedMessage {...translations.options.iDeal.steps.info.description} />
    </Typography>
    <FormActions>
      <Button type="button" color="primary" variant="contained" onClick={() => setFormStep(2)}>
        <FormattedMessage {...translations.options.iDeal.steps.info.buttons.continue} />
      </Button>
      <Button onClick={() => setSelectedPaymentMethod(null)} variant="outlined">
        <FormattedMessage {...translations.formActions.back} />
      </Button>
    </FormActions>
  </>
);

IdealInfo.propTypes = {
  setFormStep: PropTypes.func,
  setSelectedPaymentMethod: PropTypes.func,
};

IdealInfo.defaultProps = {
  setFormStep: undefined,
  setSelectedPaymentMethod: undefined,
};

export default IdealInfo;
